'use strict';

/**
 * @ngdoc service
 * @name sharedModule.ContactUs
 * @description
 * # ContactUs
 * Service in the sharedModule.
 */

(function (angular, window, undefined) {
  var ContactUsService = function (ApiService, $window) {
    'ngInject'
    var self = this;

    self.data = {
      reasons: {}
    };

    self.getContactUsReasonsByShowCode = ApiService.endpoint.get({
      url: 'api/contactUs/GetContactUsReasonsByShowCode',
      memoization: false,
      success: function (data, params) {
        self.data.reasons = data || [];
      }
    });

    self.sendEmail = ApiService.endpoint.post({
      url: 'api/contactUs/SendContactUsEmail'
    });

  };

  angular.module('sharedModule')
    .service('ContactUsService', ContactUsService);
})(angular, window);
